<template>
  <div class="rp-page">
    <div class="rp-container">
      <div class="rp-header">
        <div class="d-flex align-items-center">
          <button class="rp-back" @click="$router.push('/xisobot/main')"><b-icon icon="chevron-left"></b-icon></button>
          <h2 class="rp-title"><b-icon icon="people-fill" class="mr-2"></b-icon>Mijozlar qarz hisoboti</h2>
        </div>
        <button class="rp-btn rp-btn-secondary" @click="exportCsv" :disabled="loading || items.length === 0">
          <b-icon icon="file-earmark-excel"></b-icon> Excel
        </button>
      </div>

      <div class="rp-filters">
        <div class="rp-filter"><label>Boshlanish</label><input type="date" v-model="date1" @change="fetch"></div>
        <div class="rp-filter"><label>Tugash</label><input type="date" v-model="date2" @change="fetch"></div>
        <div class="rp-filter rp-filter-grow">
          <label>Sklad</label>
          <v-select :options="skladList" v-model="sklad_id" :reduce="s => s.id" label="name" placeholder="Barchasi" @input="fetch" />
        </div>
        <div class="rp-filter rp-filter-grow">
          <label>Mijoz turi</label>
          <v-select :options="typeOptions" v-model="client_type" :reduce="t => t.id" label="name" placeholder="Barchasi" @input="fetch" />
        </div>
        <div class="rp-filter">
          <label>Qidiruv</label>
          <input type="search" v-model="search" placeholder="Mijoz / tel...">
        </div>
        <div class="rp-filter"><label>&nbsp;</label><button class="rp-btn rp-btn-primary" @click="fetch" :disabled="loading"><b-icon icon="arrow-repeat"></b-icon> Yangilash</button></div>
      </div>

      <div class="rp-summary rp-summary-3">
        <div class="rp-card rp-c-1">
          <div class="rp-card-label">JAMI MIJOZ</div>
          <div class="rp-card-value">{{ filtered.length }}</div>
        </div>
        <div class="rp-card rp-c-4">
          <div class="rp-card-label">SO'M BALANS (mijoz qarzi)</div>
          <div class="rp-card-value" :class="totals.end_balance >= 0 ? 'rp-red' : 'rp-green'">
            {{ fmt(totals.end_balance) }} <small class="rp-muted">so'm</small>
          </div>
        </div>
        <div class="rp-card rp-c-2">
          <div class="rp-card-label">DOLLAR BALANS (mijoz qarzi)</div>
          <div class="rp-card-value" :class="totals.end_balance_dollar >= 0 ? 'rp-red' : 'rp-green'">
            $ {{ fmt(totals.end_balance_dollar) }}
          </div>
        </div>
      </div>

      <div class="rp-section">
        <h3 class="rp-block-title">
          <b-icon icon="list-ul"></b-icon> Mijozlar ro'yxati
          <span class="rp-badge rp-badge-info ml-2">Dollar va so'm alohida</span>
        </h3>
        <div class="rp-table-wrap">
          <table class="rp-table">
            <thead>
              <tr>
                <th rowspan="2">#</th>
                <th rowspan="2">Mijoz</th>
                <th rowspan="2">Telefon</th>
                <th rowspan="2">Turi</th>
                <th colspan="4" class="t-center client-som-th">SO'M kesimida</th>
                <th colspan="4" class="t-center client-usd-th">DOLLAR ($) kesimida</th>
              </tr>
              <tr>
                <th class="t-right client-som-th">Boshlang'ich</th>
                <th class="t-right client-som-th">Qarz berdik</th>
                <th class="t-right client-som-th">Qarz oldik</th>
                <th class="t-right client-som-th">Balans</th>
                <th class="t-right client-usd-th">Boshlang'ich</th>
                <th class="t-right client-usd-th">Qarz berdik</th>
                <th class="t-right client-usd-th">Qarz oldik</th>
                <th class="t-right client-usd-th">Balans</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(r, i) in filtered" :key="r.kontragent_id">
                <td><span class="rp-num">{{ i + 1 }}</span></td>
                <td class="rp-strong">{{ r.kontragent_name }}</td>
                <td class="rp-muted">{{ r.phone_number || '—' }}</td>
                <td><span class="rp-badge" :class="typeBadge(r.client_type)">{{ typeLabel(r.client_type) }}</span></td>
                <!-- SO'M -->
                <td class="t-right">{{ fmt(r.begin_balance) }}</td>
                <td class="t-right rp-green">{{ fmt(r.qarz_berdi) }}</td>
                <td class="t-right rp-red">{{ fmt(r.qarz_oldi) }}</td>
                <td class="t-right rp-strong" :class="r.end_balance > 0 ? 'rp-red' : (r.end_balance < 0 ? 'rp-green' : '')">{{ fmt(r.end_balance) }}</td>
                <!-- DOLLAR -->
                <td class="t-right">{{ fmt(r.begin_balance_dollar) }}</td>
                <td class="t-right rp-green">{{ fmt(r.qarz_berdi_dollar) }}</td>
                <td class="t-right rp-red">{{ fmt(r.qarz_oldi_dollar) }}</td>
                <td class="t-right rp-strong" :class="r.end_balance_dollar > 0 ? 'rp-red' : (r.end_balance_dollar < 0 ? 'rp-green' : '')">{{ fmt(r.end_balance_dollar) }}</td>
              </tr>
              <tr v-if="!loading && filtered.length === 0"><td colspan="12" class="rp-empty">Mijoz topilmadi</td></tr>
            </tbody>
            <tfoot v-if="filtered.length > 0">
              <tr>
                <th colspan="4" class="t-right">JAMI:</th>
                <th></th>
                <th class="t-right">{{ fmt(totals.qarz_berdi) }}</th>
                <th class="t-right">{{ fmt(totals.qarz_oldi) }}</th>
                <th class="t-right">{{ fmt(totals.end_balance) }}</th>
                <th></th>
                <th class="t-right">$ {{ fmt(totals.qarz_berdi_dollar) }}</th>
                <th class="t-right">$ {{ fmt(totals.qarz_oldi_dollar) }}</th>
                <th class="t-right">$ {{ fmt(totals.end_balance_dollar) }}</th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './report.css';
export default {
  data() {
    const today = new Date();
    const first = new Date(today.getFullYear(), today.getMonth(), 1);
    return {
      date1: this.ds(first), date2: this.ds(today),
      sklad_id: null, client_type: null,
      skladList: [], items: [],
      totals: {
        qarz_berdi: 0, qarz_oldi: 0, end_balance: 0,
        qarz_berdi_dollar: 0, qarz_oldi_dollar: 0, end_balance_dollar: 0,
      },
      search: '', loading: false,
      typeOptions: [{ id: 1, name: 'Oddiy mijoz' }, { id: 2, name: 'Usta mijoz' }, { id: 3, name: 'Zapchas mijoz' }]
    };
  },
  computed: {
    filtered() {
      if (!this.search || this.search.length < 2) return this.items;
      const q = this.search.toLowerCase();
      return this.items.filter(r => (r.kontragent_name && r.kontragent_name.toLowerCase().includes(q)) || (r.phone_number && String(r.phone_number).includes(q)));
    }
  },
  mounted() { this.loadSklads(); this.fetch(); },
  methods: {
    ds(d) { return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; },
    toUnix(s, end = false) { return Math.floor(new Date(s + (end ? 'T23:59:59' : 'T00:00:00')).getTime() / 1000); },
    fmt(v) { return (parseFloat(v) || 0).toLocaleString('ru-RU', { maximumFractionDigits: 2 }); },
    typeLabel(t) { return { 1: 'Oddiy', 2: 'Usta', 3: 'Zapchas' }[t] || '—'; },
    typeBadge(t) { return { 1: 'rp-badge-blue', 2: 'rp-badge-purple', 3: 'rp-badge-info' }[t] || 'rp-badge-warn'; },
    async loadSklads() { try { const r = await axios.get('api/v1/sklads'); this.skladList = r.data || []; } catch (e) { this.skladList = []; } },
    async fetch() {
      this.loading = true;
      try {
        const r = await axios.post('api/v1/report/clients-debt/', {
          datetime1: this.toUnix(this.date1, false), datetime2: this.toUnix(this.date2, true),
          sklad_id: this.sklad_id || null, client_type: this.client_type || null,
        });
        this.items = r.data.items || [];
        this.totals = r.data.totals || { qarz_berdi: 0, qarz_oldi: 0, end_balance: 0 };
      } catch (e) { console.error(e); }
      finally { this.loading = false; }
    },
    exportCsv() {
      const headers = [
        'Mijoz', 'Telefon', 'Turi',
        "SOM Boshlang'ich", 'SOM Qarz berdik', 'SOM Qarz oldik', 'SOM Balans',
        "USD Boshlang'ich", 'USD Qarz berdik', 'USD Qarz oldik', 'USD Balans',
      ];
      const rows = this.filtered.map(r => [
        r.kontragent_name, r.phone_number, this.typeLabel(r.client_type),
        r.begin_balance, r.qarz_berdi, r.qarz_oldi, r.end_balance,
        r.begin_balance_dollar, r.qarz_berdi_dollar, r.qarz_oldi_dollar, r.end_balance_dollar,
      ]);
      const csv = [headers, ...rows].map(r => r.map(c => `"${String(c||'').replace(/"/g,'""')}"`).join(';')).join('\n');
      const blob = new Blob(["﻿" + csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a'); a.href = url; a.download = `mijozlar_qarz_${this.date1}_${this.date2}.csv`; a.click();
      URL.revokeObjectURL(url);
    }
  }
};
</script>

<style scoped>
.client-som-th { background: #f0f9ff !important; color: #0369a1 !important; border-bottom-color: #bae6fd !important; }
.client-usd-th { background: #ecfdf5 !important; color: #047857 !important; border-bottom-color: #a7f3d0 !important; }
.rp-table td:nth-child(9), .rp-table td:nth-child(10),
.rp-table td:nth-child(11), .rp-table td:nth-child(12) {
  background: #f0fdf4;
}
</style>
